import { render } from "./Bank.vue?vue&type=template&id=3249044a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Bank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3249044a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3249044a', __exports__)) {
    api.reload('3249044a', __exports__)
  }
  
  module.hot.accept("./Bank.vue?vue&type=template&id=3249044a", () => {
    api.rerender('3249044a', render)
  })

}


export default __exports__